<template>
  <SelectComponent
    ref="selectRef"
    :model-value="modelValue"
    :options="options"
    :multiple="false"
    :placeholder="'Operación'"
    @update:model-value="val => emit('update:modelValue', val)"
    @open="emit('open')"
    :show-all="true"
    :dynamic-placeholder="false"
  >
    <template #option="{ option, isSelected, toggle }">
      <label class="flex items-center gap-2.5 px-2 py-2 cursor-pointer hover:bg-gray-50 rounded-md select-none">
        <input
          type="radio"
          :checked="isSelected"
          @change="toggle"
          class="w-4 h-4 rounded-full border-gray-300 cursor-pointer text-tuin_base-0 focus:ring-transparent"
        />
        <span class="text-gray-800 font-medium whitespace-nowrap">{{ option.name }}</span>
      </label>
    </template>
  </SelectComponent>
</template>

<script setup>
import { ref } from 'vue';
import SelectComponent from '@/components/common/SelectComponent.vue';

defineProps({
  modelValue:  { type: [String, Number], default: '' },
  options:     { type: Array,            default: () => [] },
});

const emit = defineEmits(['update:modelValue', 'open']);

const selectRef = ref(null);
defineExpose({ close: () => selectRef.value?.close() });
</script>
